import { openBlock as t, createElementBlock as o, createElementVNode as e } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, c = /* @__PURE__ */ e("path", {
  fill: "#F0F0F0",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), l = /* @__PURE__ */ e("path", {
  fill: "#D80027",
  d: "M15.652 17.391h24.179C38.552 7.578 30.16 0 20 0a20.07 20.07 0 0 0-4.348.475v16.916Zm-5.217 0V2.431C4.943 5.429 1.012 10.925.169 17.392h10.266Zm0 5.218H.169c.843 6.467 4.774 11.963 10.266 14.96v-14.96Zm5.217 0v16.916c1.4.31 2.855.475 4.348.475 10.162 0 18.552-7.578 19.83-17.391H15.653Z"
}, null, -1), s = [
  c,
  l
];
function r(d, h) {
  return t(), o("svg", n, [...s]);
}
const _ = { render: r };
export {
  _ as default,
  r as render
};
